interface MessageType {
  code: string;
  payload: string | object;
}

export function sendToFlutter(message: MessageType) {
  // @ts-ignore
  return toApp.postMessage(JSON.stringify(message));
}

export const flutterCommunicationCode: Record<string, MessageType> = {
  LOGOUT: {
    code: "WVM001",
    payload: "LOGOUT",
  },
};
